module.exports = __webpack_public_path__ + "img/jackpot-circle.701bf2d8.svg";